<template>
  <v-app>
    <v-toolbar color="primary" fixed dark app><v-toolbar-title class="ms-0 ps-3"> {{ $t("app.name") }} </v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-card-title primary-title>
              <div>
                <div class="headline ps-2 pa-1">
                  {{ $t("auth.welcomeTitle") }}
                </div>
              </div>
            </v-card-title>
            <v-form ref="loginForm" v-model="loginForm" class="pa-4 pt-6">
              <v-text-field outline v-model="model.username" :rules="[rules.email]" :label='$t("auth.emailAddress")' type="email"
                @keyup.enter="login"></v-text-field>
              <v-text-field outline v-model="model.password" :rules="[rules.required]" :label='$t("auth.password")'
                style="min-height: 96px" type="password" dense @keyup.enter="login"></v-text-field>

              <v-layout row wrap>
                <v-flex>


                  <v-subheader style="padding-top: 15px"><router-link to="/reset-password-email">{{
                    $t("auth.resetPassword")
                  }}</router-link></v-subheader>
                </v-flex>
              </v-layout>
              <v-btn @click="login" :loading="loading" block color="secondary" dark>{{ $t("auth.login") }}</v-btn>
            </v-form>
          </v-card>
          
        </v-layout>
      </v-container>

    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { getFirstAllowedPage } from "@/utils/permissionHelpers";

export default {
  title: "auth.login",
  data: () => ({
    loading: false,
    error: false,
    model: {
      username: "",
      password: "",
      code: "",
      remember_me: "",
    },
    page: 0,
    socket: null,
    dialog: false,
    email: undefined,
    loginForm: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("auth.invalidEmail"),
        length: (len) => (v) =>
          (v || "").length == len || this.$t("auth.invalidLength", { len }),
        password: (v) =>
          !!(v || "").match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()=+\-_[\]{}|;':",.<>/?éèêë])[A-Za-z\d!@#$%^&*()=+\-_[\]{}|;':",.<>/?éèêë]{8,15}$/) || this.$t("auth.passwordRule"),
        required: (v) => !!v || this.$t("auth.passwordRequired"),
      };
    },
  },

  methods: {
    async login() {
      if (this.loading)
        return;
      if (!this.$refs.loginForm.validate())
        return;
      this.error = false;
      this.loading = true;
      this.axios
        .post(this.api.ACTIONS.LOGIN, { ...this.model, provider: "users" })
        .then(({ data }) => {
          this.$store.commit("LOGIN", data.data);
          this.$store.commit("USER_NAME", data.data.username);
          // console.log(this.$store.state.USER_NAME);
          let next = { name: "Requests" };
          if (this.airportAgency(data.data.roles)) {
            next = { name: "airport/create" };
          } else {
            // Get first page user has permission for
            const userPermissions = data.data.permissions || [];
            next = getFirstAllowedPage(userPermissions);
          }
          window.getApp.$emit("APP_LOGIN_SUCCESS");
          this.$router.push(next);
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("auth.checkInfo"), "red");
          }
        })
        .then(() => (this.loading = false));
    },
   
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  content: "";
  z-index: 0;
}
</style>
